/** 
 * @license
 * MIT License
 * Copyright (c) 2021 The Perfumery, LLC
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
**/

import injectCSS from './libs/injectCSS';
import flattenMenus from './libs/flattenMenus';
import resolveElementNgScope from './libs/resolveElementNgScope';
import makeCSS from './libs/makeCSS';
import appendStyle from './libs/appendStyle';
import P21CommandPalette from './libs/P21CommandPalette';
import addP21CommandPalette from './backup';
import AppVersion from './libs/version';
import sentinel from 'sentinel-js';

makeCSS();

const isPlayInstance = window.location.hostname.includes('play');

console.log(`p21-js-injection, version ${AppVersion}`);

// window.P21CommandPalette = P21CommandPalette;

// Initialize P21CommandPalette
if (typeof window.P21CommandPalette === 'undefined') {
    window.P21CommandPalette = {
        init: {
            maxAttempts: 10,
            retryDelay: 250,
            attemptCount: 0,
        },
        injected: false,
        version: AppVersion,
    };
}
window.addP21CommandPalette = addP21CommandPalette;

if (isPlayInstance) {
    sentinel.on('.ep-main-navbar.navbar-sm.navbar-default.navbar-fixed-top', el => {
        const titleEl = document.createElement('div');
        titleEl.id = 'perfumery-p21-inject--title';
        titleEl.innerHTML = 'The Perfumery - <div>PLAY</div';

        if (isPlayInstance) {
            el.classList.add('play-nav');
        }

        el.prepend(titleEl);
    });
    // sentinel.on('#MainMenu', el => el.classList.add('play-main-menu'));
    // sentinel.on('.portal-nav-tabs', el => el.classList.add('play-portal-nav'));

    if(window.location.href.includes('login')) {
        sentinel.on('.loginbox', el => {
            const overlayEl = document.createElement('div');
            overlayEl.id = 'perfumery-p21-inject--play-overlay';
            overlayEl.innerHTML = `
                <div>
                    <i style="margin-right: 0.25em;" class="fa fa-exclamation-circle"></i>DO NOT USE WITH PRODUCTION DATA
                </div>
            `;

            el.parentElement.prepend(overlayEl);
            el.style.border = '8px solid red;'
            // document.body.appendChild(overlayEl);
        });
    }
}
// const addP21Title = (mutationsList, observer) => {
//     // Check for the DOM node
//     const headerNavEl = document.querySelector('.ep-main-navbar.navbar-sm.navbar-default.navbar-fixed-top');
//     if (headerNavEl === null) {
//         return;
//     }

//     const titleEl = document.createElement('div');
//     titleEl.style = `
//         position: absolute;
//         display: flex;
//         justify-content: center;
//         top: 0;
//         left: 0;
//         right: 0;
//         bottom: 0;
//         align-content: center;
//         align-items: center;
//         line-height: 1;
//         font-size: 2rem;
//         color: white;
//         font-family: serif;
//         font-weight: 600;
//         letter-spacing: 1px;
//     `;
//     titleEl.innerHTML = 'The Perfumery - PLAY';

//     headerNavEl.prepend(titleEl);

//     observer.disconnect();
//     console.log('Nav mutation observer disconnected.');
// };

window.addEventListener('DOMContentLoaded', (event) => {
    console.log(`DOMContentLoaded: ${document.readyState}`);
    addP21CommandPalette();

    // const watchBodyForNavHeader = new MutationObserver(addP21Title);
    // watchBodyForNavHeader.observe(document.body, {childList: true, subtree: true});
});

sentinel.on('.cfp-hotkeys-container', el => {
    (() => {
        const el = document.querySelector('.cfp-hotkeys-container');
        const hotkeysTableEl = el.querySelector('table');
        const hotkeysLastRowEl = _.last(hotkeysTableEl.querySelectorAll('tr'))
        const hotkeysTemplateEl = hotkeysLastRowEl.cloneNode(true);

        hotkeysTemplateEl.removeAttribute('ng-repeat');
        hotkeysTemplateEl.classList.remove('ng-scope');
        hotkeysTemplateEl.firstElementChild.firstElementChild.removeAttribute('ng-repeat');
        hotkeysTemplateEl.firstElementChild.firstElementChild.classList.remove('ng-scope');


        const newHotkeyEl = hotkeysTemplateEl.cloneNode(true);
        newHotkeyEl.firstElementChild.firstElementChild.innerHTML = 'ctrl + shift + p';
        newHotkeyEl.lastElementChild.innerHTML = 'Toggle P21 Command Palette';

        hotkeysLastRowEl.parentElement.appendChild(newHotkeyEl);    
    })();
    
});
